export default __webpack_public_path__ + "static/media/react.b183c4cd.png";